import { ReactNode } from "react";
import s from "./WithoutSpacing.module.scss";

type Props = {
  children: ReactNode;
};

const WithoutSpacing = ({ children }: Props) => (
  <div className={s.withoutSpacing}>{children}</div>
);

export default WithoutSpacing;
